import React, { createContext, PropsWithChildren } from "react";
import { OAuth } from "./OAuth";

export const AuthContext = createContext<OAuth>(null!);

interface AuthProviderProps {
  client: OAuth;
}

const AuthProvider: React.FC<PropsWithChildren<AuthProviderProps>> = ({
  children,
  client,
}) => {
  return <AuthContext.Provider value={client}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
